import { ITableSetting } from "../../../../Table/BasicTable";
import {
  IconWrapper,
  ImageWrapper,
} from "../../../ui-components/pageLayout/TableSettingsComponents";
import noImage from "../../../../../../resources/missing-img.png";
import { MdModeEditOutline } from "react-icons/md";
import { CMSAsset } from "@client/models/CMS/cmsAsset";

export const LiveChannelsTableSettings: ITableSetting<CMSAsset>[] = [
  {
    id: "image-id",
    align: "left",
    name: "",
    path: "gg",
    content: (data: CMSAsset) => (
      <ImageWrapper backgroundSize={data.getImage() ? "contain" : "cover"}>
        <div
          className="image"
          style={{
            backgroundImage: `url(${data.getImage() || noImage})`,
          }}
        />
      </ImageWrapper>
    ),
  },
  {
    id: "name-id",
    align: "left",
    name: "NAME",
    path: "NAME",
    content: (data: CMSAsset) => <div>{data.getDisplayName()}</div>,
  },
  {
    id: "id-id",
    align: "left",
    name: "ID",
    path: "ID",
    content: (data: CMSAsset) => <div>{data.getUniqueId()}</div>,
  },
  {
    id: "published-id",
    align: "center",
    name: "PUBLISHED",
    path: "PUBLISHED",
    content: (data: CMSAsset) => (
      <input type="checkbox" readOnly checked={data.isPublished} />
    ),
  },
  {
    id: "created-id",
    align: "left",
    name: "CREATED",
    path: "CREATED",
    content: (data: CMSAsset) => <div>{data.createdDate}</div>,
  },
  {
    id: "changed-id",
    align: "left",
    name: "CHANGED",
    path: "CHANGED",
    content: (data: CMSAsset) => <div>{data.changedDate}</div>,
  },
  {
    id: "edit-id",
    align: "right",
    name: "",
    path: "gh",
    content: (data: CMSAsset) => (
      <IconWrapper>
        <MdModeEditOutline />
      </IconWrapper>
    ),
  },
];
